<template>
  <v-select
    auto-select-first
    label="Channel"
    clearable
    :items="options"
    v-model="innerValue"
    item-text="text"
    item-value="value"
    :return-object="false"
    @change="onChange($event)"
    v-bind="resetProps"
    hide-details
  />
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    value: [String, Object],
    hideDetails: Boolean
  },
  data() {
    return {
      innerValue: this.value,
    };
  },


  watch: {
    value(n) {
      this.innerValue = n;
    },
    innerValue(value) {
      this.$emit("input", value);
    },
  },

  methods: {
    emitBlur() {
      this.$emit("blur");
    },
    onChange() {
      this.$emit("onChange");
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    resetProps() {
      return { ...this.$attrs };
    },
    options() {
      return [
        {
          value: "Email",
          text: `Email`,
        },
        {
          value: "Call",
          text: `Call`,
        },
        {
          value: "Chat",
          text: `Chat`,
        },
        {
          value: "SMS",
          text: `SMS`,
        },        
        {
          value: "Other",
          text: `Other`,
        },
      ];
    },
  },
};
</script>